// src/registerServiceWorker.js

/* eslint-disable no-console */

import { register } from "register-service-worker";

export const serviceWorkerCallbacks = {
  ready() {
    console.log("Service worker is active.");
  },
  registered() {
    console.log("Service worker has been registered.");
  },
  cached() {
    console.log("Content has been cached for offline use.");
  },
  updatefound() {
    console.log("New content is downloading.");
  },
  updated() {
    // Keep the current document and its already-loaded asset graph together.
    // The next navigation receives the revalidated shell and current hashes.
    console.log("New content is available for the next navigation.");
  },
  offline() {
    console.log(
      "No internet connection found. App is running in offline mode.",
    );
  },
  error(error) {
    console.error("Error during service worker registration:", error);
  },
};

if (process.env.NODE_ENV === "production") {
  register(
    `${process.env.BASE_URL}service-worker.js`,
    serviceWorkerCallbacks,
  );
}
